import React from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Compatibility from './components/Compatibility';
import ProblemSolution from './components/ProblemSolution';
import ExtensionPreview from './components/ExtensionPreview';
import HowItWorks from './components/HowItWorks';
import Pricing from './components/Pricing';
import FAQ from './components/FAQ';
import Footer from './components/Footer';
import SuccessBanner from './components/SuccessBanner';
import ScrollToTop from './components/ScrollToTop';
import ThankYou from './pages/ThankYou';
import PromoBanner from './components/PromoBanner';
import Testimonials from './components/Testimonials';
import SalesToast from './components/SalesToast';

const LandingPage = () => (
  <>
    <SuccessBanner />
    <PromoBanner />
    <Navbar />
    <main>
      <Hero />
      <Compatibility />
      <ProblemSolution />
      <ExtensionPreview />
      <HowItWorks />
      <Testimonials />
      <Pricing />
      <FAQ />
    </main>
    <Footer />
    <ScrollToTop />
    <SalesToast />
  </>
);

function App() {
  return (
    <LanguageProvider>
      <div className="min-h-screen bg-[#0a0a0f] font-sans selection:bg-orange-500/30 selection:text-white">
        <HashRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/obrigado" element={<ThankYou />} />
          </Routes>
        </HashRouter>
      </div>
    </LanguageProvider>
  );
}

export default App;